import { ResponsivePie } from "@nivo/pie";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveCalendar } from '@nivo/calendar'

import { useQuery } from "@apollo/client";
import {GET_PROJECT_SUPERVISOR, GET_TASK_SUPERVISOR, GET_USER_FROM_ADMIN} from '../graphql/queries'
import { LinearProgress } from "@material-ui/core";

export const GraphicUserPanel = () => {
    const { data: userData, loading: userLoading, error: userError } = useQuery(
        GET_USER_FROM_ADMIN
      );
    
      if (userLoading) return <div>Loading...</div>;

      const getPlannerList = userData.findAllUser
        .slice()
        .filter(({ role }) => role === "planner")
        .length

        const getWorkerList = userData.findAllUser
        .slice()
        .filter(({ role }) => role === "worker")
        .length
    
  return (
    <>
      <ResponsivePie
        data={[
          {
            id: "Worker",
            label: "Worker",
            value: getWorkerList,
            color: "hsl(345, 70%, 50%)",
          },
          {
            id: "Planner",
            label: "Planner",
            value: getPlannerList,
            color: "rgb(111, 66, 193)",
          },
        ]}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        colors={{ scheme: "paired" }}
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextColor="#333333"
        radialLabelsLinkColor={{ from: "color" }}
        sliceLabelsSkipAngle={10}
        sliceLabelsTextColor="#333333"
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        legends={[
          {
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: 0,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: "#999",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#000",
                },
              },
            ],
          },
        ]}
      />
    </>
  );
};

export const GraphicProjectPlanner = () => {
  const {
    data: projectData,
    loading: projectLoading,
    error: projectError,
  } = useQuery(GET_PROJECT_SUPERVISOR, {
    pollInterval: 10000
  });

  if (projectLoading) return <div>Loading...</div>;

  const getApproveProject = projectData.findAllProjectSupervisor
    .slice()
    .filter(({ status }) => status === "approve").length;

    const getRejectProject = projectData.findAllProjectSupervisor
    .slice()
    .filter(({ status }) => status === "reject").length;

    const getReturnProject = projectData.findAllProjectSupervisor
    .slice()
    .filter(({ status }) => status === "return").length;

    const getSubmitProject = projectData.findAllProjectSupervisor
    .slice()
    .filter(({ status }) => status === "submit").length;

    const getCompleteProject = projectData.findAllProjectSupervisor
    .slice()
    .filter(({ status }) => status === "complete").length;

    const getDoneProject = projectData.findAllProjectSupervisor
    .slice()
    .filter(({ status }) => status === "done").length;

    const getReturnToWorkerProject = projectData.findAllProjectSupervisor
    .slice()
    .filter(({ status }) => status === "return to worker").length;

    console.log(getReturnToWorkerProject)

  return (
    <>
      <ResponsiveBar
        data={[
          {
            status: "Approve",
            approve: getApproveProject,
            approveColor: "hsl(58, 70%, 50%)",
          },
          {
            status: "Reject",
            reject: getRejectProject,
            rejectColor: "hsl(58, 70%, 50%)",
          },
          {
            status: "Return",
            return: getReturnProject,
            returnColor: "hsl(58, 70%, 50%)",
          },
          {
            status: "Submit",
            submit: getSubmitProject,
            submitColor: "hsl(58, 70%, 50%)",
          },
          {
            status: "Done",
            done: getDoneProject,
            doneColor: "hsl(58, 70%, 50%)",
          },
          {
            status: "Return to Worker",
            "return to worker": getReturnToWorkerProject,
            returnToWorkerColor: "hsl(58, 70%, 50%)",
          },
          {
            status: "Complete",
            complete: getCompleteProject,
            completeColor: "hsl(58, 70%, 50%)",
          },
        ]}
        keys={["approve", "reject", "return", "submit", "done", "return to worker", "complete"]}
        indexBy="status"
        margin={{ top: 50, right: 130, bottom: 70, left: 60 }}
        padding={0.3}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={{ scheme: "paired" }}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "#38bcb2",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "#eed312",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 2,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Status",
          legendPosition: "middle",
          legendOffset: 32,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Project List",
          legendPosition: "middle",
          legendOffset: -40,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: "custom", modifiers: [["darker", 3]] }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
      />
    </>
  );
};
  
export const GraphicProjectCalendar = () => {
  let newArrTask = [];
  let newArrProject = [];

  const {
    data: projectData,
    loading: projectLoading,
    error: projectError,
  } = useQuery(GET_PROJECT_SUPERVISOR, { pollInterval: 1000 });
  const {
    data: taskData,
    loading: taskLoading,
    error: taskError,
  } = useQuery(GET_TASK_SUPERVISOR, { pollInterval: 1000 });

  if (projectLoading) return <LinearProgress />;
  if (taskLoading) return <LinearProgress />;

  taskData.findAllTaskSupervisor
    .slice()
    .sort(
      ({ project_id: previousID }, { project_id: currentID }) =>
        previousID - currentID
    )
    .map((o) => {
      return newArrTask.push(o);
    });

  projectData.findAllProjectSupervisor
    .slice()
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map((o) => {
      return newArrProject.push(o);
    });

  console.log(newArrTask);
  console.log(newArrProject);

  let filteredTaskList = newArrProject.map((item) => {
    let joinedArr = newArrTask.filter((o) => o.project_id === item.id);
    return { ...item, taskList: [...joinedArr] };
  });

  console.log(filteredTaskList)

  const newData = filteredTaskList.filter(
    ({ status }) =>
      status === "approve" ||
      status === "done" ||
      status === "complete" ||
      status === "submit" ||
      status === "return" ||
      status === "return to worker"
  )
  .map((item, key) => {
    const convertToDate = (inputDate) => {
      let date = new Date(+inputDate).toISOString().slice(0, 10);
      console.log(date)
      return date
    };
    return {
      day: convertToDate(item.start_date),
      value: `${item.id}`
    };
   })

  console.log(filteredTaskList);
  return (
    <>
      <ResponsiveCalendar
        data={newData}
        from="2020-01-01"
        to="2021-07-12"
        emptyColor="#eeeeee"
        colors={["#61cdbb", "#97e3d5", "#e8c1a0", "#f47560"]}
        margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
        yearSpacing={40}
        monthBorderColor="#ffffff"
        dayBorderWidth={2}
        dayBorderColor="#ffffff"
        legends={[
          {
            anchor: "bottom-right",
            direction: "row",
            translateY: 36,
            itemCount: 4,
            itemWidth: 42,
            itemHeight: 36,
            itemsSpacing: 14,
            itemDirection: "right-to-left",
          },
        ]}
      />
    </>
  );
};
  
  